/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
const Paypal = ({ Amount, attributes }) => {

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const { setPaymentRes, setPaymentLoading } = useContext(MyContext);

    useEffect(() => {
        const loadPayPalScript = () => {
            const script = document.createElement('script');
            script.src = `https://www.paypal.com/sdk/js?client-id=${attributes.split(",")[0]}`;
            script.async = true;
            script.onload = () => setIsScriptLoaded(true);
            document.body.appendChild(script);
        };
        if (!isScriptLoaded) {
            loadPayPalScript();
        }
    }, [isScriptLoaded]);

    useEffect(() => {
        if (isScriptLoaded && window.paypal) {
            renderPayPalButton();
        }
    }, [isScriptLoaded]);


    const renderPayPalButton = () => {
        secureLocalStorage.setItem("Amount", Amount);
        setPaymentLoading(false);
        window.paypal.Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                    purchase_units: [{
                        amount: {
                            value: Amount,
                        },
                    }],
                });
            },
            onApprove: (data, actions) => {
                return actions.order.capture().then((details) => {
                    setPaymentRes("PaymentDone");
                    sessionStorage.setItem("transactionid", details.id);
                });
            },
            onCancel: () => {
                setPaymentRes("PaymentFaild");

            },
            onError: (err) => {
                console.error(err);
            },
        }).render('#paypal-button-container');
    };


    return (
        <div className='w-full'>
            <div id="paypal-button-container"></div>
        </div>
    );
};

export default Paypal;
/* jshint ignore:end */

